(() => {
  if (window.PickupQuantity) return;
  function refresh(section) {
    const quantity = Number(section.querySelector('input[name="quantity"]')?.value || 1);
    for (const info of section.querySelectorAll('.pickup-availability-info[data-stock]')) {
      const status = info.querySelector('.pickup-status[data-original]');
      if (!status) continue;
      const over = quantity > Number(info.dataset.stock);
      const text = over ? window.PickupQuantity.orderText : status.dataset.original;
      if (status.textContent !== text) status.textContent = text;
      status.style.color = over ? 'blue' : '';
      const time = info.querySelector('.pickup-time');
      if (time) time.hidden = over;
    }
  }
  window.PickupQuantity = { orderText: window.variantStrings.addToCart || 'Add to cart' };
  const all = () => document.querySelectorAll('section[id^="MainProduct-"]').forEach(refresh);
  document.addEventListener('input', event => {
    if (event.target.matches('input[name="quantity"]')) {
      const section = event.target.closest('section[id^="MainProduct-"]');
      if (section) refresh(section);
    }
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) all();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', all);
  all();
})();